module.exports = __webpack_public_path__ + "images/icon_fullscreen_in_56b58f2f0fbb91b9e9453c370b31ca2b.svg";